module.exports = __webpack_public_path__ + "static/media/company.cfa3c182.svg";